import { Skeleton as MUISkeleton } from "@material-ui/lab";
import React from "react";

export const SchedulingLinkCardSkeleton = () => (
  <div className="cw-flex cw-flex-col cw-gap-2 cw-max-w-[425px] cw-px-4 cw-py-2 cw-border cw-border-solid cw-border-default cw-rounded-lg cw-shadow-md">
    <Skeleton width={180} height={21} />
    <div className="cw-flex cw-gap-2">
      <Skeleton width={80} height={18} />
      <Skeleton width={120} height={18} />
    </div>
    <div className="cw-flex cw-justify-evenly cw-gap-2 cw-rounded">
      <Skeleton width={67} height={26} />
      <Skeleton width={67} height={26} />
      <Skeleton width={67} height={26} />
    </div>
  </div>
);
function Skeleton({ width, height }: { width: number; height: number }) {
  return <MUISkeleton variant="rect" width={width} height={height} className="cw-rounded-md" />;
}
